import React, { useEffect } from "react";
import { Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePurchaseRoModel } from "../purchaseRoModel";
import { IPurchaseRoDetail } from "../purchaseRoType"
import YhTag from "@/components/YhTag";
import { useDictModel } from "../../../base/dict/dictModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

type statusType = {
    "purchase-return.create": string,
    "purchase-return.stock-io": string,
    "purchase-return.settle": string,
    "purchase-return.change": string,
    [key: string]: any
}
export function DataTable() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { language, setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { dataSource, selectedRowKeys, pgCfg, descRows, loadData, setSelectedRowKeys, setDescRows } = usePurchaseRoModel();
    const { getTreeSelectOne, getSelectedDictOne, getTreeNodeName, getTreeNodeOne } = useDictModel();

    const statusColor: statusType = {
        "purchase-return.create": "blue",
        "purchase-return.stock-io": "cyan",
        "purchase-return.settle": "green",
        "purchase-return.change": "red",
    }
    const columns: ColumnsType<IPurchaseRoDetail> = [
        {
            // title: '序号',
            title: Locale["SN"],
            width: 80,
            render: (text, record, index) => `${index + 1}`
        }, {
            // title: '采购退货单号',
            title: Locale["Purchase Return Doc No."],
            dataIndex: 'returnCode',
            width: 180,
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '单据状态',
            title: Locale["Status"],
            dataIndex: 'status',
            width: 140,
            // render:(text)=><YhTag color={statusColor[getTreeNodeName(text)]} text={getTreeNodeName(text)}/>,
            render: (text) => <YhTag color={statusColor[text]} text={language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string} />,
        }, {
            // title: '支付状态',
            title: Locale["Payment status"],
            width: 160,
            dataIndex: 'payStatus',
            render: (text) => getTreeNodeName(text)

        }, {
            // title: '单据日期',
            title: Locale["Creation Time"],
            dataIndex: 'createTime',
            width: 180,
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '供应商名称',
            title: Locale["Supplier Name"],
            dataIndex: 'supplierName',
            width: 150,
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '联系人',
            title: Locale["Contact"],
            dataIndex: 'contact',
            width: 120,
        }, {
            // title: '联系电话',
            title: Locale["Contact Number"],
            dataIndex: 'phone',
            width: 140,
        }, {
            // title: '退货数量',
            title: Locale["Return Qty"],
            dataIndex: 'totalNum',
            width: 120,
        }, {
            // title: '退货金额',
            title: Locale["Return Amount"],
            dataIndex: 'totalAmount',
            width: 140,
        }, {
            // title: '应收金额',
            title: Locale["Receivable Amount"],
            dataIndex: 'totalAmount',
            width: 140,
        }, {
            // title: '已收金额',
            title: Locale["Received Amount"],
            dataIndex: 'amountReceived',
            width: 140,
        }, {
            // title: '制单员',
            title: Locale["Creator"],
            dataIndex: 'createUser',
            width: 120,
        }, {
            // title: '库管员',
            title: Locale["Storekeeper"],
            dataIndex: 'storekeeper',
            width: 120,
        }, {
            // title: '出库时间',
            title: Locale["Stock-out Time"],
            dataIndex: 'stockIoTime',
            width: 180,
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '结算类型',
            title: Locale["Payment Type"],
            width: 160,
            dataIndex: 'payType',
            // render: (text) => getTreeNodeName(text)
            render: (text) => {
                if (text) {
                    return language == "zh-CN" ? getTreeNodeOne(text)[0].name : getTreeNodeOne(text)[0].nameEn as string
                } else {
                    return ""
                }
            }
        }, {
            // title: '结算员',
            title: Locale["Reckoner"],
            dataIndex: 'reckoner',
            width: 140,
        }, {
            // title: '结算时间',
            title: Locale["Settle Time"],
            dataIndex: 'settleTime',
            width: 180,
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            // title: '核销时间',
            title: Locale["Write off time"],
            width: 180,
            ellipsis: true,
            dataIndex: 'payTime',
        }, {
            // title: '备注',
            title: Locale["Note"],
            dataIndex: 'note',
            width: 140,
        }
    ];
    useEffect(() => {
        loadData()
    }, [])
    //点击行选高亮
    const onRow = (record: IPurchaseRoDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    return (
        <Table
            style={{ cursor: "pointer" }}
            rowKey={record => record.id as string}
            rowSelection={{
                onChange: (selectedRowKeys: React.Key[], selectedRows: IPurchaseRoDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => {
                return {
                    onClick: () => onRow(record)
                };
            }}
            scroll={{ x: 'max-content', y: 460 }}
        />
    )
}
